<script lang="ts" setup>
import { useSidebar } from '../ui/sidebar/utils'

const { open, isMobile } = useSidebar()
</script>

<template>
  <header class="flex top-0 bg-background h-12 shrink-0 items-center gap-2 border-b px-2">
    <div class="flex w-full items-center gap-2">
      <div>
        <UiSidebarTrigger class="size-8" />
      </div>
      <UiSeparator
        orientation="vertical"
        class="mr-2 h-4"
      />
      <div
        v-if="!open || isMobile"
        class="h-8 overflow-hidden"
      >
        <template v-if="isMobile">
          <img
            src="/icon.svg"
            class="h-full"
          >
        </template>
        <template v-else>
          <img
            src="/light-logo.png"
            alt="DartsSpace logo"
            class="hidden dark:flex h-full w-auto"
          >
          <img
            src="/dark-logo.png"
            alt="DartsSpace logo"
            class="dark:hidden h-full w-auto"
          >
        </template>
      </div>
      <div class="flex-1 w-full" />
      <div class="ml-auto flex gap-1 md:gap-2">
        <ClientOnly>
          <LayoutLanguageSwitcher />
          <LayoutDarkModeSwitcher />
        </ClientOnly>
        <UserDropdown />
      </div>
    </div>
  </header>
</template>
